import { set, get } from 'lodash';

import { PERMISSION_CATEGORY_DEFINE } from 'static/Constants';

const categorizeCondition = ({
  cate,
  fieldName,
  permission,
  nextGroupedPermit,
}) => {
  if (cate?.permission.includes(permission?.permissionDisplayName)) {
    setPermissionValue({ fieldName, permission, nextGroupedPermit });
    return true;
  }

  return false;
};

const setPermissionValue = ({ fieldName, permission, nextGroupedPermit }) => {
  const currentValue = get(nextGroupedPermit, fieldName);
  set(nextGroupedPermit, fieldName, [...(currentValue || []), permission]);
};

const handleCategorizeOnePermission = ({ permission, nextGroupedPermit }) => {
  for (let [key, value] of Object.entries(PERMISSION_CATEGORY_DEFINE)) {
    const isMatch = categorizeCondition({
      cate: value,
      fieldName: key,
      permission,
      nextGroupedPermit,
    });

    if (isMatch) return;
  }
};

const categorizePermisison = ({ rolePermissions }) => {
  if (!rolePermissions || rolePermissions?.length <= 0) return {};

  let nextGroupedPermit = {};

  rolePermissions.forEach((permission) =>
    handleCategorizeOnePermission({ permission, nextGroupedPermit })
  );

  return nextGroupedPermit;
};

const lookForPermission = ({ searchText, rolePermissions }) => {
  if (!searchText) return rolePermissions;

  return rolePermissions.filter((permission) => {
    let permissionName = permission?.permissionDisplayName;

    if (typeof permissionName === 'string') {
      return permissionName
        .toLocaleLowerCase()
        .includes(searchText.toLowerCase());
    } else {
      return true;
    }
  });
};

const getRolePermissionList = ({
  type,
  availPermissions,
  rolePermissionListData,
  formRole,
}) => {
  const filterToGetRemainAvailPermisions = (permit) =>
    !(formRole?.values?.permissions || []).find(
      (addedPermit) => addedPermit?.permissionName === permit?.permissionName
    );

  const mapToPermissionListWithNewItemInfo = (permit, type = 'add') => {
    if (!rolePermissionListData) return permit;

    const isFoundInPrevPermissionList = rolePermissionListData.find(
      (prevPermit) => prevPermit?.permissionName === permit?.permissionName
    );

    if (type === 'add' && isFoundInPrevPermissionList) {
      return { ...permit, isNew: true };
    } else if (type === 'remove' && !isFoundInPrevPermissionList) {
      return { ...permit, isNew: true };
    }

    return permit;
  };

  //*NOTE - 20/1/2021 - arcording to requirement we need to remove super admin permission from adding list
  const filterPermissionNotSuperAdminInAddPermisionList = (permit) =>
    permit?.permissionName === 'SUPER_ADMIN' ? false : permit;

  switch (type) {
    case 'add':
      return (availPermissions || [])
        .filter(filterPermissionNotSuperAdminInAddPermisionList)
        .filter(filterToGetRemainAvailPermisions)
        .map((permit) => mapToPermissionListWithNewItemInfo(permit, type));
    case 'remove':
      return (formRole?.values?.permissions || []).map((permit) =>
        mapToPermissionListWithNewItemInfo(permit, type)
      );
    default:
      return rolePermissionListData;
  }
};

const BYPASS_PERMISSION_DISPLAY_NAME = 'BYPASS PRODUCT INTERNAL MAINTENANCE';

const isRivirMember = (memberId) => Number(memberId) === 1;

const applyBypassPermissionFilter = (categorized, memberId) => {
  if (isRivirMember(memberId)) return categorized;

  return Object.fromEntries(
    Object.entries(categorized).map(([groupName, permissions]) => [
      groupName,
      permissions.filter(
        (p) => p.permissionDisplayName !== BYPASS_PERMISSION_DISPLAY_NAME
      ),
    ])
  );
};

const mapToCategoriesAndSearchPermisison = ({
  availPermissions,
  rolePermissionListData,
  searchText,
  searchCategories,
  type,
  formRole,
  memberId,
}) => {
  const rolePermissions = getRolePermissionList({
    type,
    availPermissions,
    rolePermissionListData,
    formRole,
  });

  const searchedPermission = lookForPermission({
    searchText,
    rolePermissions,
  });

  const categorizedResult = applyBypassPermissionFilter(
    categorizePermisison({ rolePermissions: searchedPermission }),
    memberId
  );

  const searchCategoryFiltered = Object.fromEntries(
    searchCategories
      .filter((categoryName) => categorizedResult?.[categoryName]?.length > 0)
      .map((categoryName) => [categoryName, categorizedResult[categoryName]])
  );

  return [searchCategoryFiltered, categorizedResult];
};

export { mapToCategoriesAndSearchPermisison };
